import { ActiveLabel } from '@bybeam/doctopus-types';
import { capitalizeFirstLetter } from '@bybeam/platform-lib/format/capitalize';
import { TemporaryDocument, TemporaryExistingDocument } from '@platform-ui/@types/document.js';

function getDisplayLabel(label: ActiveLabel) {
  if (label?.displayName) return label.displayName;
  return label.name
    .split('_')
    .map((part) => capitalizeFirstLetter(part))
    .join(' ');
}

function isExistingDocument(doc: TemporaryDocument): doc is TemporaryExistingDocument {
  return 'id' in doc;
}

const DISPLAY_PREDICTION_THRESHOLD = 0.5;

export { getDisplayLabel, isExistingDocument, DISPLAY_PREDICTION_THRESHOLD };
